import React from 'react';
// import logo from './logo.svg';
// import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

//TODO: Criar Rotas!
//TODO: Colocar como default Header / Footer
//Criar componente de Home Banca / Admin / Produtora
import Routes from './Routes'


function App() {
  return (
    <Routes/>
  );
}

export default App;
